import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { UserResolver } from './core/services/user.resolver';
import { HomeComponent } from './home/components/home/home.component';
import { LayoutComponent } from './layout/components/layout/layout.component';
import { UploadReportComponent } from './report/components/upload-report/upload-report.component';
import { hasUnsavedChangesGuard } from './shared/services/unsaved-changes.guard';

const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [authGuard],
    resolve: { user: UserResolver },
  },
  {
    path:'auth',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path:'public',
    loadChildren: () => import('./public/public.module').then((m) => m.PublicModule),
  },
  {
    path: 'smart-report-v2',
    loadChildren: ()=> import('./smart-report-v2/smart-report-v2.module').then((m) => m.SmartReportV2Module)
  },
  {
    path: 'smart-report',
    canActivate:[authGuard],
    loadChildren: ()=> import('./smart-report-v2/smart-report-v2.module').then((m) => m.SmartReportV2Module)
  },
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full'
  },
  {
    path:'',
    component: LayoutComponent,
    canActivate: [authGuard],
    resolve: { user: UserResolver },
    children:[
      {
        path: 'report',
        loadChildren: () => import('./report/report.module').then((m) => m.ReportModule),
      },
      {
        path: 'upload-report',
        component: UploadReportComponent,
        canDeactivate: [hasUnsavedChangesGuard]
      },
      {
        path: 'laboratory',
        loadChildren: () => import('./lab/lab.module').then((m) => m.LabModule),
      },
      {
        path: 'old-reports',
        loadChildren: () => import('./old-report/old-report.module').then((m) => m.OldReportModule),
      },
      {
        path: 'insurance-records',
        loadChildren: () => import('./insurance-records/insurance-records.module').then((m) => m.InsuranceRecordsModule),
      },
      {
        path: 'prescription',
        loadChildren: () => import('./prescription/prescription.module').then((m) => m.PrescriptionModule),
      },
      {
        path: 'chart',
        loadChildren: () => import('./charts/charts.module').then((m) => m.ChartsModule),
      },
      {
        path: 'comparison',
        loadChildren: () => import('./comparison/comparison.module').then((m) => m.ComparisonModule),
      },
      {
        path: 'user',
        loadChildren: () => import('./user/user.module').then((m) => m.UserModule),
      },
      {
        path: 'vhs',
        loadChildren: () => import('./vhs/vhs.module').then((m) => m.VhsModule),
      },
      {
        path: 'document-scanner',
        loadChildren: () => import('./document-scanner/document-scanner.module').then((m) => m.DocumentScannerModule),
      },
      {
        path: 'insurance',
        loadChildren: () => import('./insurance/insurance.module').then((m) => m.InsuranceModule),
      },
      {
        path: 'preauth',
        loadChildren: () => import('./pre-auth/pre-auth.module').then((m) => m.PreauthModule),
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
      },
      {
        path: 'radiology',
        loadChildren: () => import('./radiology/radiology.module').then((m) => m.RadiologyModule),
      },
      {
        path: 'medical-record-analysis',
        loadChildren: () => import('./medical-record-analysis/medical-record-analysis.module').then((m) => m.MedicalRecordAnalysisModule),
      },
      {
        path: 'medical-record-history',
        loadChildren: () => import('./medical-record-history/medical-record-history.module').then((m) => m.MedicalRecordHistoryModule),
      },
      {
        path: 'icd-code-analysis',
        loadChildren: () => import('./icd-code-analysis/icd-code-analysis.module').then((m) => m.IcdCodeAnalysisModule),
      },
      {
        path: 'extract-input',
        loadChildren: () => import('./extract-input/extract-input.module').then((m) => m.ExtractInputModule),
      },
      {
        path: 'risk-score',
        loadChildren: () => import('./risk-score/risk-score.module').then((m) => m.RiskScoreModule),
      },

      {
        path:'',
        redirectTo:'report',
        pathMatch:'full'
      }
    ]
  },
  {
    path: '**',
    redirectTo:'auth'
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes,  {scrollPositionRestoration: 'enabled'})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
